import React from 'react'
import {Divider, Grid, Typography, useTheme, Zoom} from '@material-ui/core'
import {CamItem, CamResponse} from '../../data-service'
import MovieCard from '../../components/movie-card/MovieCard'
import {Grow} from '@material-ui/core'
import Search from '../../components/search/Search'
import {useParams} from 'react-router-dom'
import Player from '../../components/player/Player'

interface DetailProps {
    data: CamResponse;
    useThemeHook?: any;
    useParamsHook?: any;
}

export default function Detail({data, useThemeHook = useTheme, useParamsHook = useParams}: DetailProps) {
	const {id} = useParamsHook()
	const theme = useThemeHook()
	const spacing: number = theme.spacing()

	const selectedItem: CamItem | undefined = data.items.find(el => el.id === id)
	const item = selectedItem ? selectedItem : {stream: '', img: ''}

	return <Grid
		style={{backgroundColor: 'transparent', minHeight: '35vh'}}
		container
		spacing={2}
		direction="row"
		justifyContent="flex-start"
		alignItems="stretch"
	>
		<Grid item xs={12}>
			<Typography variant="h5" component="h1"
				style={{paddingTop: `${spacing * 2}px`, paddingBottom: `${spacing * 2}px`}}>
				{selectedItem?.title}
			</Typography>
		</Grid>

		<Grid item xs={12}>
			<Player movieUrl={item.stream} posterUrl={item.img}/>
		</Grid>

		<Grid item xs={12}>
			<Typography variant="caption"
				style={{paddingTop: `${spacing * 2}px`, paddingBottom: `${spacing * 2}px`}}>
				{selectedItem?.description}
			</Typography>

			<Typography variant="caption" style={{color: 'transparent'}}>
				{item.stream}
			</Typography>
		</Grid>
	</Grid>
}